import { Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function ConditionChip({ item: condition }) {
    const label = formatConditionLabel(condition)
    return (
        <Stack direction="row" alignItems="center" spacing={0.5}>
            <Iconify icon="mdi:filter-variant" sx={{ fontSize: 14, color: "text.secondary" }} />
            <Typography variant="caption" color="text.secondary">
                {label}
            </Typography>
        </Stack>
    )

    function formatConditionLabel(c) {
        const valueStr = formatValue(c.value)
        return `${c.field} ${c.operator} ${valueStr}`
    }

    function formatValue(val) {
        if (Array.isArray(val)) return val.join(", ")
        if (val && typeof val === "object") {
            if (val.period && val.interval) return `${val.interval} ${val.period}`
            return JSON.stringify(val)
        }
        return String(val ?? "")
    }
}
